<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                <section class="mu-d-flex">
                    <h1 class="mu-mb-00">External system connection</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ (isNewConnection) ? helpTextCreate.title : helpTextEdit.title }}
                                <a v-if="isNewConnection" :href="helpTextCreate.url" target="_blank">Read more...</a>
                                <a v-if="!isNewConnection" :href="helpTextEdit.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
                <section>
                    <div role="group" class="mcc-button-group" v-if="!isNewConnection">
                        <button class="mcc-button mcc-button--outline" id="exportBtn" @click="exportFiles()" title="Export">
                            <mcc-icon name="export" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Export</span>
                        </button>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <nav aria-label="breadcrumb" class="">
            <ol class="mcc-breadcrumb">
                <li>Integrate</li>
                <li>
                    <a class="table-link" @click="redirectToList()">External systems</a>
                </li>
                <li>
                    <router-link :to="CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId">{{externalSystemName}}</router-link>
                </li>
                <li>
                    <router-link :to="CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId + '/apis/'+ apiId">{{externalSystemAPIName}}</router-link>
                </li>
                <li aria-current="page">{{(isNewConnection) ? 'Create new' : connectionName}}</li>
            </ol>
        </nav>
        <div class="mcc-row" v-if="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="mcc-card mu-p-06">
            <div class="mcc-row">
            <div class="mcc-col mcc-col-xs-12 mcc-col-md-12 mcc-col-sm-12">
                                        <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="externalSystemReadOnly" v-if="isReadOnly" color="warning">
                                            <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                                            <p>
                                                <strong>Warning!</strong>
                                                <br />{{readOnlyMsg}}
                                                <br />
                                            </p>
                                        </mcc-alert>
                                    </div>
                                </div>
       
                <div class="mcc-row" v-show="fetchCall">
                    <div class="mcc-col">
                        <form ref="restConnectionForm" id="restConnectionForm" @submit.prevent="saveRestConnection($event)" novalidate>
                            <div style="position:relative">
                                <div v-if="!updateCall" class="spinner-overlay">
                                    <div class="spinner-background"></div>
                                    <div class="spinner-flex">
                                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        </svg>
                                    </div>
                                </div>
                                <div class="mcc-row">
                                    
                                    <div class="mcc-col mcc-col-12 mcc-col-md-6  ">
                                        <div class="mcc-card fullHeightCard">
                                            <div class="mcc-card__header">
                                                <h2 class="mcc-card__title">Active connection</h2>
                                            </div>
                                            <div class="mcc-card__body">
                                                <div class="mcc-row">
                                                    <div class="mcc-col">
                                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container input-gap">
                                                            <label for="connectionType">Connection type</label>
                                                            <input type="text" id="connectionType" name="connectionType" readonly="readonly" value="REST">
                                                        </div>
                                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container input-gap">
                                                            <label for="name" class="mfc-label--required">Name</label>
                                                            <input type="text" id="name" name="name" required placeholder="Name" maxlength="50" :disabled="isReadOnly" ref="name" :value="dto.name" :pattern="nameRegex" @change="updateName($event)">
                                                        </div>
                                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container input-gap">
                                                            <label for="baseURL" class="mfc-label--required">Base URL</label>
                                                            <input type="text" id="baseURL" name="baseURL" required placeholder="Base URL" :disabled="isReadOnly" ref="baseURL" :value="dto.baseUrl" @input="updateBaseURL($event)">
                                                        </div>

                                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container input-gap">
                                                            <label for="timeout">Timeout</label>
                                                            <div class="mfc-input-group">
                                                                <input type="number" min="5" name="timeout" placeholder="Timeout" id="timeout" :disabled="isReadOnly" :value="dto.timeout" @change="dto.timeout = $event.target.value">
                                                                <span>seconds</span>
                                                            </div>
                                                        </div>
                                                        <div class="mfc-select-wrapper input-gap">
                                                            <label for="authenticationMethod" class="mfc-label--required">Authentication method</label>
                                                            <select :disabled=isReadOnly @change="handleAuthTypeChange($event)" ref="authMethodRef" name="authenticationMethod" id="authenticationMethod" required>
                                                                <option :selected="dto.authType == 'BASIC_AUTH'" value="BASIC_AUTH">Basic authentication</option>
                                                                <option :selected="dto.authType == 'API_KEY'" value="API_KEY">API token</option>
                                                                <option :selected="dto.authType == 'NO_AUTH'" value="NO_AUTH">No authentication</option>
                                                                <option :selected="dto.authType == 'OAUTH_API_KEY'" value="OAUTH_API_KEY">OAuth 2.0 client credentials</option>
                                                                <option :selected="dto.authType == 'OAUTH_BASIC'" value="OAUTH_BASIC">OAuth 2.0 password</option>
                                                            </select>
                                                        </div>
                                                        <div class="mcc-row" v-if="dto.authType == 'BASIC_AUTH'">
                                                            <div class="mcc-col">
                                                                <div class="mfc-input-wrapper mu-d-block marginTop0 mfc-form-input-container input-gap">
                                                                    <label for="username" class="mfc-label--required">Username</label>
                                                                    <input type="text" id="username" name="username" required placeholder="Username" maxlength="100" :disabled="isReadOnly" ref="username" :value="dto.username" @change="updateUserName($event)">
                                                                </div>
                                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container input-gap">
                                                                    <label for="password">Password</label>
                                                                    <input type="password" id="password" name="password" maxlength="100" autocomplete="off" :disabled="isReadOnly" placeholder="Password" :value="dto.password" @change="dto.password = $event.target.value">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="mcc-row" v-if="dto.authType == 'API_KEY'">
                                                            <div class="mcc-col">
                                                                <div>
                                                                    <div class="mfc-input-wrapper mu-d-block marginTop0 mfc-form-input-container input-gap">
                                                                        <label for="apikey" class="mfc-label--required">API key</label>
                                                                        <input type="text" id="apikey" name="apikey" required placeholder="API key" maxlength="1000" :disabled="isReadOnly" ref="apikey" :value="dto.apiKey" @change="updateAPIKey($event)">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="mcc-row" v-if="(dto.authType == 'OAUTH_BASIC' || dto.authType == 'OAUTH_API_KEY')">
                                                            <div class="mcc-col">
                                                                <div>
                                                                    <div class="mfc-input-wrapper mu-d-block marginTop0 mfc-form-input-container input-gap">
                                                                        <label for="authURL" class="mfc-label--required">Auth URL</label>
                                                                        <input type="text" id="authURL" name="authURL" required placeholder="Auth URL" maxlength="1000" :disabled="isReadOnly" ref="authURL" :value="dto.authURL" @change="updateAuthUrl($event)">
                                                                    </div>
                                                                    <div class="mfc-input-wrapper mu-d-block mfc-form-input-container input-gap">
                                                                        <label for="clientId" class="mfc-label--required">Client ID</label>
                                                                        <input type="text" id="clientId" name="clientId" required placeholder="Client ID" maxlength="500" :disabled="isReadOnly" ref="clientId" :value="dto.clientId" @change="updateClientId($event)">
                                                                    </div>
                                                                    <div class="mcc-row" v-if="dto.authType == 'OAUTH_BASIC'">
                                                                        <div class="mcc-col">
                                                                            <div class="mfc-input-wrapper mu-d-block marginTop0 mfc-form-input-container input-gap">
                                                                                <label for="authUserName" class="mfc-label--required">Username</label>
                                                                                <input type="text" id="authUserName" name="authUserName" required placeholder="Username" maxlength="100" :disabled="isReadOnly" ref="authUserName" :value="dto.authUserName" @change="updateAuthUserName($event)">
                                                                            </div>
                                                                            <div class="mfc-input-wrapper mu-d-block marginBottom0 mfc-form-input-container input-gap">
                                                                                <label for="authPassword" class="mfc-label--required">Password</label>
                                                                                <input type="password" id="authPassword" name="authPassword" ref="authPassword" required maxlength="200" autocomplete="off" :disabled="isReadOnly" placeholder="Password" :value="dto.authPassword" @change="updateAuthPassword($event)">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="mcc-row" v-if="dto.authType == 'OAUTH_API_KEY'">
                                                                        <div class="mcc-col">
                                                                            <div>
                                                                                <div class="mfc-input-wrapper mu-d-block marginTop0 marginBottom0 mfc-form-input-container input-gap">
                                                                                    <label for="clientSecret" class="mfc-label--required">Client secret</label>
                                                                                    <input type="text" id="clientSecret" name="clientSecret" required placeholder="Client secret" maxlength="1000" :disabled="isReadOnly" ref="clientSecret" :value="dto.clientSecret" @change="updateClientSecret($event)">
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="mfc-input-wrapper mu-d-block mfc-form-input-container input-gap">
                                                                        <label for="scope">Scope</label>
                                                                        <input type="text" id="scope" name="scope" placeholder="Scope" :disabled="isReadOnly" ref="scope" :value="dto.scope" @change="dto.scope = $event.target.value">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="mcc-row" v-if="showTestUrl">
                                                            <div class="mcc-col">
                                                                <div class="mfc-input-wrapper mu-d-block marginTop0 mfc-form-input-container input-gap">
                                                                    <label for="serviceName" class="mfc-label--required">Test URL</label>
                                                                    <div id="serviceNameDiv" class="mfc-input-group mcc-col-12 mfc-input-group--has-help-text mfc-input-group--has-validation-text">
                                                                        <input class="splitInputReadOnly" :value="dto.baseUrl+'/'" readonly>
                                                                        <input type="text" id="serviceName" name="serviceName" required :disabled="isReadOnly"  ref="serviceName" :value="dto.serviceName" @change="updateServiceName($event)">
                                                                        <div class="mfc-invalid-feedback"></div>
                                                                    </div>                                                                    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mcc-col mcc-col-12  mcc-col-md-6 ">
                                        <div class="mcc-card fullHeightCard">
                                            <div class="mcc-card__header">
                                                <div class="mu-position-relative">
                                                    <h2 class="mcc-card__title">Additional properties</h2>
                                                    <div class="mfc-checkbox-wrapper mfc-form-input-container mu-position-absolute mu-top-0 mu-end-0">
                                                        <input type="checkbox" class="mfc-switch" :disabled="isReadOnly" id="showAdditionaProp" ref="showAdditionaProp" name="showAdditionaProp" :checked="dto.showAdditionalProperties" @change="handleShowAdditionalProperties($event.target.checked)">
                                                        <label for="showAdditionaProp">Show</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mcc-card__body" v-show="dto.showAdditionalProperties">
                                                <mfc-row-repeater @ready="addRequiredClassToLabels" stacked="false" ref="customConnectionProperties" id="customConnectionProperties">
                                                    <mfc-input type="text" label="Name" maxlength="50" name="name" id="operationName" :disabled="isReadOnly" dfAttr="dfAttr"></mfc-input>
                                                    <mfc-input type="text" label="Value" maxlength="100" name="value" id="operationValue" :disabled="isReadOnly" vfAttr="vfAttr"></mfc-input>
                                                </mfc-row-repeater>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                    <div class="mu-d-flex mu-justify-content-end d-flex justify-content-end mu-mt-05">
                                        <div role="group" class="mcc-button-group mcc-button-group--spaced mcc-button-group-flex-wrap">
                                            <router-link class="mu-mr-05" :to="CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId + '/apis/'+ apiId" v-if="isNewConnection">
                                                <button type="button" class="mcc-button mcc-button--outline" title="Cancel" id="cancelBtn">
                                                    <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                                                </button>
                                            </router-link>
                                            <button class="mcc-button mcc-button--soft-danger" type="button" v-if="!isNewConnection && !isReadOnly" @click="$refs.deleteRestConnection.show()" title="Delete" id="delRestConBtn">
                                                <mcc-icon name="trash" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Delete</span>
                                            </button>
                                            <button class="mcc-button mcc-button--outline" title="Test connection" id="testConnection" type="submit">
                                                <mcc-icon name="connected" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Test connection</span>
                                            </button>
                                            <button class="mcc-button mcc-button--success" v-if="!isReadOnly" title="Save" id="saveBtn" type="submit">
                                                <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                            </button>
                                        </div>
                                  
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div></div>
        
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--danger mcc-dialog--xs" v-if="dataLoaded" id="deleteRestConnection" ref="deleteRestConnection">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Delete connection</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.deleteRestConnection.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div v-if="!isDefaultConnection">
                        Are you sure you want to delete this REST connection?
                    </div>

                    <div v-if="isDefaultConnection">
                        This connection is marked as active. Continue? </div>
                </div>
                <div class="mcc-dialog__footer">

                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" @click="$refs.deleteRestConnection.close()">No</button>
                        <button type="button" class="mcc-button mcc-button--danger" @click="deleteRestConnection($event)">Yes</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
</div>
</template>

<script>
import ExternalSystemAPI from "../../../services/ExternalSystemAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import ImportExportAPI from "../../../services/ImportExportAPI";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

export default {
    name: "RestConnectionEdit",
    data() {
        return {
            dto: {
                authType: "BASIC_AUTH"
            },
            connectionName: "",
            externalSystemName: "",
            externalSystemAPIName: "",
            activeConnection: "",
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            helpTextCreate: constantMessages.BREADCRUMB_HELP["externalSystemConnection.Rest.Create"],
            helpTextEdit: constantMessages.BREADCRUMB_HELP["externalSystemConnection.Rest.edit"],
            externalSystemId: this.$route.params.externalSystemId,
            apiId: this.$route.params.apiId,
            connectionId: this.$route.params.connectionId,
            connectionType: [],
            showHelpText: false,
            fetchCall: true,
            updateCall: true,
            isNewConnection: false,
            dataLoaded: false,
            connectionContainer: {},
            isDefaultConnection: false,
            showTestUrl: false,
            addtionalProperties: [],
            isReadOnly: false,
            readOnlyMsg: constantMessages.MESSAGES["error.externalsystems.readonly"]
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        this.loadConnectionInfo(false);
        this.setupMutationObserver()
    },
    methods: {
        setupMutationObserver() {
        const observer = new MutationObserver(() => {
            this.addRequiredClassToLabels();
        });

        const targetNode = this.$el.querySelector('#customConnectionProperties');
        if (targetNode) {
            observer.observe(targetNode, { childList: true, subtree: true });
        }
    },
        addRequiredClassToLabels() {
        this.$nextTick(() => {
            const inputs = this.$el.querySelectorAll('mfc-input');
            
            if (!inputs.length) {
                return;
            }
            
            inputs.forEach(input => {
                const label = input.querySelector('label');
                
                if (label) {
                    if (input.getAttribute('name') === 'name-rr-0' || input.getAttribute('name') === 'value-rr-0') {
                        label.classList.add('mfc-label--required');
                    }
                } 
            });
        });
    },
        handleAddrowEventForRowRepeater() {
            let self = this;
            setTimeout(() => {
                //self.updateCurrentStatusOfDataField();
                //self.updatecurrentStatusOfValueField();
                $(".mc-row-repeater .mc-row-repeater__created-rows .mc-row-repeater__repeated-inputs [dfAttr=dfAttr]").off("change").on("change", function (e) {
                    self.updateDataField(e);
                });
                $(".mc-row-repeater .mc-row-repeater__created-rows .mc-row-repeater__repeated-inputs [vfAttr=vfAttr]").off("change").on("change", function (e) {
                    self.updateValueField(e);
                });
            }, 1000);
        },
        handleRowRemoveOperation() {
            Utils.removeExistingMessages("dfAttr", this.nameRegex, 50);
        },
        updateDataField(event) {
            this.performValidationsForDataField(event.target, event.target.value);
        },
        updateValueField(event) {
            this.performValidationsForValueField(event.target, event.target.value);
        },
        updateCurrentStatusOfDataField() {
            let self = this;
            let alldataFields = $("[dfAttr=dfAttr]");
            $.each(alldataFields, function (i, df) {
                let dataVal = df.value;
                self.performValidationsForDataField(df, dataVal);
            });
        },
        updatecurrentStatusOfValueField() {
            let self = this;
            let allValueFields = $("[vfAttr=vfAttr]");
            $.each(allValueFields, function (i, df) {
                let dataVal = df.value;
                self.performValidationsForValueField(df, dataVal);
            });
        },
        performValidationsForValueField(component, dataVal) {
            let valid = true;
            let pattern = new RegExp(this.descRegex);
            if (dataVal == "") {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.value.required"])
                component[0].classList.add("ms-is-invalid")
                valid = false;
            } else if (dataVal.length > 100) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.value.maxlength"])
                component[0].classList.add("ms-is-invalid")
                valid = false;
            } else if (!pattern.test(dataVal)) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.value.invalid"])
                component[0].classList.add("ms-is-invalid")
                valid = false;
            } else {
                Utils.removeExistingMessages("vfAttr", this.descRegex, 50);
                component[0].classList.remove("ms-is-invalid")
                valid = true;
            }
            return valid;
        },
        performValidationsForDataField(component, dataVal) {
            let valid = true;
            let pattern = new RegExp(this.nameRegex);
            if (dataVal == "") {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.name.required"])
                component[0].classList.add("ms-is-invalid")
                valid = false;
            } else if (dataVal.length > 50) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.maxLength.50"])
                component[0].classList.add("ms-is-invalid")
                valid = false;
            } else if (!pattern.test(dataVal)) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.name.invalid"])
                component[0].classList.add("ms-is-invalid")
                valid = false;
            }  else if (!Utils.isPropertyValid("dfAttr", "error.name.unique")){
                valid = false;
            } else {
                Utils.removeExistingMessages("dfAttr", this.nameRegex, 50);
                component[0].classList.remove("ms-is-invalid")
                valid = true;
            }
            return valid;
        },
        handleShowAdditionalProperties(isShowAddProp) {
            let self = this;
            if (isShowAddProp) {
                this.dto.showAdditionalProperties = isShowAddProp;
                self.setRowRepeaterData(self.addtionalProperties);
            } else {
                self.addtionalProperties = [];
                $.each(self.$refs.customConnectionProperties.values, function (i, val) {
                    let obj = {
                        "name": val.Name,
                        "value": val.Value
                    };
                    self.addtionalProperties.push(obj);
                });
                this.dto.showAdditionalProperties = isShowAddProp;
            }
        },
        setRowRepeaterData(addtionalProperties) {
            let self = this;
            if (addtionalProperties.length > 0) {
                setTimeout(() => {
                    self.$refs.customConnectionProperties.setData(addtionalProperties, {});
                }, 1000);
            }
        },
        updateBaseURL(e) {
            if (e.target.value == "") {
                displayErrorMessage($(this.$refs.baseURL), "Base URL is required")
                this.$refs.baseURL.classList.add("ms-is-invalid");
                return true;
            } else {
                this.$refs.baseURL.classList.remove("ms-is-invalid");
            }
            this.showTestUrl = false;
            this.dto.baseUrl = e.target.value;
            this.updateShowTestURL();
        },
        async updateShowTestURL() {
            await this.$nextTick();
            this.showTestUrl = true;
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid");
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid");
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.dto.name = event.target.value;
        },
        updateUserName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.username), "User name is required")
                self.$refs.username.classList.add("ms-is-invalid");
            } else {
                self.$refs.username.classList.remove("ms-is-invalid")
            }
            self.dto.username = event.target.value;
        },
        updateAPIKey(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.apikey), "API key is required")
                self.$refs.apikey.classList.add("ms-is-invalid");
            } else {
                self.$refs.apikey.classList.remove("ms-is-invalid")
            }
            self.dto.apiKey = event.target.value;
        },
        updateAuthUrl(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.authURL), "Auth url is required")
                self.$refs.authURL.classList.add("ms-is-invalid");
            } else {
                self.$refs.authURL.classList.remove("ms-is-invalid")
            }
            self.dto.authURL = event.target.value;
        },
        updateClientId(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.clientId), "Client id is required")
                self.$refs.clientId.classList.add("ms-is-invalid");
            } else {
                self.$refs.clientId.classList.remove("ms-is-invalid")
            }
            self.dto.clientId = event.target.value;
        },
        updateAuthUserName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.authUserName), "AuthUserName is required")
                self.$refs.authUserName.classList.add("ms-is-invalid");
            } else {
                self.$refs.authUserName.classList.remove("ms-is-invalid")
            }
            self.dto.authUserName = event.target.value;
        },
        updateAuthPassword(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.authPassword), "Auth password is required")
                self.$refs.authPassword.classList.add("ms-is-invalid");
            } else {
                self.$refs.authPassword.classList.remove("ms-is-invalid")
            }
            self.dto.authPassword = event.target.value;
        },
        updateClientSecret(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.clientSecret), "clientSecret is required")
                self.$refs.clientSecret.classList.add("ms-is-invalid");
            } else {
                self.$refs.clientSecret.classList.remove("ms-is-invalid")
            }
            self.dto.clientSecret = event.target.value;
        },
        updateServiceName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.serviceName), "Test URL is required")
                self.$refs.serviceName.classList.add("ms-is-invalid");
            } else {
                self.$refs.serviceName.classList.remove("ms-is-invalid")
            }
            self.dto.serviceName = event.target.value;
        },
        handleAuthTypeChange(event) {
            this.dto.username = "";
            this.dto.password = "";
            this.dto.apiKey = "";
            this.dto.authURL = "";
            this.dto.clientId = "";
            this.dto.clientSecret = "";
            this.dto.authUserName = "";
            this.dto.authPassword = "";
            this.dto.scope = "";
            this.dto.authType = event.target.value;
            this.$refs.restConnectionForm.update();
        },
        loadConnectionInfo(fetchRef) {
            let self = this;
            self.fetchCall = fetchRef;

            let url =
                "/integrate/external-systems/" +
                self.apiId +
                "/restconnections/" +
                self.connectionId;
            if (self.connectionId == "new") {
                self.isNewConnection = true;
                self.helpText = constantMessages.BREADCRUMB_HELP["fileconnection.create"];
                url =
                    "/integrate/external-systems/" +
                    self.apiId +
                    "/restconnections/api-info";
            }
            ExternalSystemAPI.getConnectionInfo(url)
                .then(result => {
                    if (result == null || result == "") {
                        self.$router.push(self.CONTEXT_PATH + "/integrate/externalsystems");
                        EventBus.$emit("error-notification", {
                            msg: "Error while fetching connection"
                        });
                        return;
                    }
                    self.connectionContainer = result.connectionInfo;
                    self.isReadOnly = result.readOnly;
                    self.externalSystemId = result.connectionInfo.externalSystemId;
                    self.externalSystemName = result.connectionInfo.externalSystemName;
                    self.externalSystemAPIName = result.connectionInfo.externalSystemAPIName;

                    self.dto = result.connectionInfo.restConnection;
                    if (self.dto.authType == null) {
                        self.dto.authType = "BASIC_AUTH";
                    }
                    if (self.dto.baseUrl == null) {
                        self.dto.baseUrl = "";
                    }
                    self.addtionalProperties = [];
                    $.each(self.dto.customConnectionProperties, function (i, val) {
                        let obj = {
                            "name": val.name,
                            "value": val.value
                        };
                        self.addtionalProperties.push(obj);
                    });
                    self.connectionName = self.dto.name;
                    self.isDefaultConnection = self.connectionContainer.activeConnectionId != null && self.connectionContainer.activeConnectionId == self.connectionId;
                    self.dataLoaded = true;
                    let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.systemconnection.details"] + " - " + self.connectionName;
                    if (self.isNewConnection) {
                        pageTitle = constantMessages.PAGEHEADER_TITLE["menu.systemconnection.details"] + " - Create new";
                    }
                    EventBus.$emit("update-pageTitle", pageTitle);
                })
                .finally(function () {                    
                    self.showTestUrl = true;
                    self.fetchCall = true;
                    setTimeout(() => {
                        let content = self.dto.baseUrl+'/';
                        document.querySelector('#serviceNameDiv span').textContent = content;
                    });                    
                    if (self.dto.showAdditionalProperties) {
                        self.handleShowAdditionalProperties(true);
                    }
                });
        },
        deleteRestConnection(e) {
            let self = this;
            let endPoint = "";
            if (self.isDefaultConnection) {
                endPoint = "/delete-ref";
            }
            self.updateCall = false;
            ExternalSystemAPI.deleteFileConnection(
                self.connectionId,
                self.apiId, endPoint
            ).then(response => {
                self.$refs.deleteRestConnection.close()
                self.updateCall = true;
                EventBus.$emit("success-notification", {
                    msg: constantMessages.MESSAGES[response.message]
                });
                this.$router
                    .push(
                        this.CONTEXT_PATH +
                        "/integrate/externalsystems/" +
                        self.externalSystemId +
                        "/apis/" + self.apiId
                    )
            });
        },
        saveRestConnection(e) {
            let self = this;
            let form = $('#restConnectionForm')
            let formInvalid = false;
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                formInvalid = true
                if(!self.dto.showAdditionalProperties)
                return;
            }
            
            let btnObj = $(document.activeElement);
            if ($(btnObj).prop("tagName") == "BUTTON") {
                btnObj = $(btnObj);
            }
            if (btnObj[0].id == "testConnection") {
                self.testConnection();
                return;
            }
            let connectionId = self.connectionContainer.externalConnection.id != null ? self.connectionContainer.externalConnection.id : "new";
            if (self.dto.showAdditionalProperties) {
                let nameFieldComp;
                let nameFieldValue;
                let valueFieldComp;
                let valueFieldvalue
                let isValidNameField = true;
                let isValidValField = true;
                let isValid = true
                let customConProp = [];
                $(".mcc-row-repeater .mcc-row-repeater__row").each(function (index, row) {
                    nameFieldComp = $(row).find("input[name^=name]");
                    nameFieldValue = $(nameFieldComp).val();
                    valueFieldComp = $(row).find("input[name^=value]");
                    valueFieldvalue = $(valueFieldComp).val();
                    if ($(nameFieldComp)[0].name !== 'name-rr-0') {
                        isValidNameField = self.performValidationsForDataField(nameFieldComp, nameFieldValue);
                    }
//                    if ($(valueFieldComp)[0].name !== 'value-rr-0') {
//                        isValidValField = self.performValidationsForValueField(valueFieldComp, valueFieldvalue)
//                    }
//                    if (!isValidNameField || !isValidValField) {
//                        isValid = false
//                    }
                })
                if (!isValid || formInvalid) {
                    return;
                }

                $(".mcc-row-repeater .mcc-row-repeater__row").each(function (index, row) {
                    nameFieldComp = $(row).find("input[name^=name]");
                    nameFieldValue = $(nameFieldComp).val();

                    valueFieldComp = $(row).find("input[name^=value]");
                    valueFieldvalue = $(valueFieldComp).val();

                    let obj = {
                        "name": nameFieldValue,
                        "value": valueFieldvalue,
                    };
                    customConProp.push(obj);
                })

                self.dto.customConnectionProperties = customConProp;

            } else {
                self.dto.customConnectionProperties = [];
            }
            self.connectionContainer.restConnection = self.dto;
            self.updateCall = false;
            ExternalSystemAPI.saveRestConnection(
                self.connectionContainer,
                connectionId,
                self.apiId
            ).then(response => {
                self.updateCall = true;
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "name") {
                           displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                           self.$refs.name.classList.add("ms-is-invalid");
                           self.updateCall = true;
                            return;
                        }
                        else if(k == "encrypt"){
                            EventBus.$emit('error-notification', {
                                "msg": constantMessages.MESSAGES[response.messages[k]]
                            });
                            self.updateCall = true;
                            return;
                        }
                       
                    }
                } else {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });

                    if (self.isNewConnection) {

                        this.$router
                            .push(
                                this.CONTEXT_PATH +
                                "/integrate/externalsystems/" +
                                self.externalSystemId +
                                "/apis/" + self.apiId +
                                "/rest/" + response.data.id
                            )
                    } else {
                        self.loadConnectionInfo(true);
                        self.connectionName = response.data.name;
                    }
                }
            });
        },
        testConnection() {
            let self = this;
            self.updateCall = false;
            ExternalSystemAPI.testRestConnection(
                self.connectionContainer,
                self.connectionId,
                self.apiId
            ).then(response => {
                self.updateCall = true;
                if (response.error) {
                    EventBus.$emit('error-notification', {
                        msg: response.message
                    });
                } else {
                    EventBus.$emit("success-notification", {
                        msg: response.message
                    });

                }
            });
        },
        exportFiles() {
            ImportExportAPI.exportFiles('RESTCONNECTION', this.connectionId);
        },
        redirectToList() {
            localStorage.setItem("externalSystemList", "externalSystemList");

            this.$router.push(
                this.CONTEXT_PATH + '/integrate/externalsystems'
            );
        }
    }
};
</script>

<style scoped>
.marginTop0 {
    margin-top: 0 !important;
}

.marginBottom0 {
    margin-bottom: 0 !important;
}

.fullHeightCard {
    min-height: 100%;
}
</style>
